import { render, staticRenderFns } from "./notification-square.vue?vue&type=template&id=6a41ac06&lang=pug&"
import script from "./notification-square.vue?vue&type=script&lang=js&"
export * from "./notification-square.vue?vue&type=script&lang=js&"
import style0 from "./notification-square.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports